import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../_metronic/layout/core'
import { RecordsKeeperAIBreadCrumbs } from '../core/_constants'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
// import RecordsKeeperAIGenerator from '../components/RecordsKeeperAIGenerator'
import { ToolTipUI } from '../../widgets/components/UI/ToolTipUI'
import folderIcon from '../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import moreOption from '../../../../_metronic/assets/images/svg/data-room/more-options-small-icon.svg'
import DepartmentModal from '../components/RecordsClassifications/DepartmentModal'
import AddCategoryModal from '../components/RecordsClassifications/AddCategoryModal'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useThemeMode } from '../../../../_metronic/partials'
import { useAuth } from '../../auth'
import { deleteClassification, getAiEmail, getClassification } from '../core/_requests'
import { toast } from 'react-toastify'
import { Dropdown } from 'react-bootstrap'
import AddProjectModal from '../components/RecordsClassifications/AddProjectModal'
import { DeleteClassificationModal } from '../components/RecordsClassifications/DeleteClassificationModal'
import Skeleton from 'react-loading-skeleton'
import { useSettingsData } from '../../../hooks/getSettingsData'
import { useUpdateSettingsData } from '../../../hooks/updateSettingsData'
import { Link, useNavigate } from 'react-router-dom'
import RequestFileModal from '../components/RecordsAndFiles/RequestFileModal'
import threeDots from '../../../../_metronic/assets/images/svg/investor/threeDots.svg'
import { FileUpload } from '../../widgets/components/FileUpload'
import { allowedFileTypes } from '../../../core/_constants'

const RecordsClassifications = () => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const { mode } = useThemeMode()
  const [departmentModal, setDepartmentModal] = useState(false)
  const [categoryModal, setCategoryModal] = useState(false)
  const [projectModal, setProjectModal] = useState(false)
  const [departmentListLoading, setDepartmentListLoading] = useState<boolean>(false)
  const [categoryListLoading, setCategoryListLoading] = useState<boolean>(false)
  const [timePeriodLoading, setTimePeriodLoading] = useState<boolean>(false)
  const [projectListLoading, setProjectListLoading] = useState<boolean>(false)

  // States for selections in different levels
  const [selectedFolderLevel1, setSelectedFolderLevel1] = useState('')
  const [selectedFolderLevel2, setSelectedFolderLevel2] = useState('')
  const [selectedFolderLevel3, setSelectedFolderLevel3] = useState(null)
  const [selectedFolderLevel4, setSelectedFolderLevel4] = useState('')
  const [selectedFolderLevel5, setSelectedFolderLevel5] = useState(null)

  const [toggleStates, setToggleStates] = useState({
    isYearlyChecked: false,
    isMonthlyChecked: false,
    isQuarterlyChecked: false,
  })

  const [departmentList, setDepartmentList] = useState<any>([])
  const [categoryList, setCategoryList] = useState<any>([])
  const [projectList, setProjectList] = useState<any>([])
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>()
  const [openDeleteConfirmationModal, setOpenDeleteConfirmationModal] = useState<boolean>(false)
  const [deleteClassificationId, setDeleteClassificationId] = useState<string | null>(null)
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false)
  const [clickedDepartment, setClickedDepartment] = useState<string>('')
  const [clickedCategory, setClickedCategory] = useState<string>('')
  const [type, setType] = useState<string>('')
  const { settingsData } = useSettingsData()
  const { updateSettings } = useUpdateSettingsData()
  const navigate = useNavigate()

  useEffect(() => {
    updateSettings()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  //states for handling edit
  const [editDepartmentId, setEditDepartmentId] = useState<string>('')
  const [editDetailsLoading, setEditDetailsLoading] = useState<boolean>(false)
  const [editDetailsData, setEditDetailsData] = useState<any>()
  const [fileCount, setFileCount] = useState()
  // Handle folder selection for any level
  const handleFolderSelect = (level: number, id: any) => {
    switch (level) {
      case 1:
        setSelectedFolderLevel1(id)
        break
      case 2:
        setSelectedFolderLevel2(id)
        break
      case 3:
        setSelectedFolderLevel3(id === selectedFolderLevel3 ? null : id)
        break
      case 4:
        setSelectedFolderLevel4(id)
        break
      case 5:
        setSelectedFolderLevel5(id === selectedFolderLevel5 ? null : id)
        break
      default:
        break
    }
  }

  const getDepartmentList = async () => {
    if (!companyId) return
    const pageSize = 10
    const page = 1
    const type = 'LevelOne'
    const All = true
    try {
      setDepartmentListLoading(true)
      setCategoryListLoading(true)
      setProjectListLoading(true)

      const {
        data: { data, success, errors },
      } = await getClassification(companyId, type, All, pageSize, page)

      if (success) {
        setDepartmentList(data?.data)
        if (data?.data?.length >= 0) {
          setSelectedFolderLevel1(data?.data[0]?.levelOneId)
          setClickedDepartment(data?.data[0]?.name)
          getCategoryList(data?.data[0]?.levelOneId)
        }
      } else {
        setCategoryListLoading(false)
        setProjectListLoading(false)
        toast.error(errors.name)
      }
    } catch (err) {
      setCategoryListLoading(false)
      setProjectListLoading(false)
      console.error(err) // Add error logging
      setCategoryListLoading(false)
      setProjectListLoading(false)
    } finally {
      setDepartmentListLoading(false)
    }
  }

  useEffect(() => {
    getDepartmentList()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getCategoryList = async (selectedFolderLevel1: string) => {
    if (!companyId) return
    const pageSize = 10
    const page = 1
    const type = 'LevelTwo'
    const All = true
    setCategoryListLoading(true)
    setProjectListLoading(true)
    try {
      const {
        data: { data, success, errors },
      } = await getClassification(companyId, type, All, pageSize, page, selectedFolderLevel1)
      if (success) {
        setCategoryList(data?.data)
        getProjectList(data?.data[0]?.levelTwoId)
        setSelectedFolderLevel2(data?.data[0]?.levelTwoId)
        setClickedCategory(data?.data[0]?.name)
      } else {
        getProjectList(data?.data[0]?.levelTwoId)
        setSelectedFolderLevel2(data?.data[0]?.levelTwoId)
        setCategoryList([])
        toast.error(errors[0])
      }
    } catch (err) {
      setProjectListLoading(false)
    } finally {
      setCategoryListLoading(false)
      setProjectListLoading(false)
    }
  }

  useEffect(() => {
    if (departmentList?.length > 0) getCategoryList(selectedFolderLevel1)
  }, [selectedFolderLevel1]) // eslint-disable-line react-hooks/exhaustive-deps

  const getTimePeriod = async () => {
    if (!companyId) return
    setTimePeriodLoading(true)

    try {
      const {
        data: { data, success, errors },
      } = await getAiEmail(companyId)

      if (success) {
        const transformedData = [
          {
            isMonthlyChecked: data.isMonthly || false,
            isQuarterlyChecked: data.isQuarterly || false,
            isYearlyChecked: data.year !== 'CY' ? true : false,
          },
        ]

        setToggleStates(transformedData[0])
      } else {
        toast.error(errors[0])
      }
    } catch (err) {
      console.error('Error fetching time periods:', err)
    } finally {
      setTimePeriodLoading(false)
    }
  }

  useEffect(() => {
    getTimePeriod()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getProjectList = async (selectedFolderLevel2: string) => {
    if (!companyId) return
    setProjectListLoading(true)
    const pageSize = 10
    const page = 1
    const type = 'LevelThree'
    const All = true
    try {
      const {
        data: { data, success, errors },
      } = await getClassification(companyId, type, All, pageSize, page, selectedFolderLevel2)
      if (success) {
        setProjectList(data?.data)
        setSelectedFolderLevel4(data?.data[0]?.levelThreeId)
      } else {
        setProjectList([])
        toast.error(errors[0])
      }
    } catch (err) {
    } finally {
      setProjectListLoading(false)
    }
  }

  useEffect(() => {
    if (categoryList?.length > 0) getProjectList(selectedFolderLevel2)
  }, [selectedFolderLevel2]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleDeleteClassification = async () => {
    if (!companyId) return
    try {
      setDeleteLoading(true)
      const typeMapping: any = {
        Department: 'LevelOne',
        Category: 'LevelTwo',
        Case: 'LevelThree',
      }

      const mappedType = typeMapping[type]
      const {
        data: { success, errors },
      } = await deleteClassification(companyId, deleteClassificationId, mappedType)
      if (success) {
        toast.success(`${type} deleted successfully`)
        if (type === 'Department') {
          getDepartmentList()
        } else if (type === 'Category') {
          getCategoryList(selectedFolderLevel1)
        } else if (type === 'Case') {
          getProjectList(selectedFolderLevel2)
        }
      } else {
        toast.error(errors[0])
      }
    } catch (err) {
      console.log(err)
    } finally {
      setDeleteLoading(false)
      setOpenDeleteConfirmationModal(false)
    }
  }

  const editDetailsClassificationData = async (editDepartmentId: string, type: string) => {
    if (!companyId) return
    try {
      setEditDetailsLoading(true)
      const All = false
      const {
        data: { data, success },
      } = await getClassification(companyId, type, All, null, null, editDepartmentId)
      if (success) {
        setEditDetailsData(data?.data[0])
      }
    } catch (err) {
      console.log(err)
    } finally {
      setEditDetailsLoading(false)
    }
  }

  const handleToggle = (e: any, year: string) => {
    const isChecked = e.target.checked

    setToggleStates((prevStates: any) => ({
      ...prevStates,
      [year]: isChecked,
    }))

    let payload: any = null

    if (year === 'isYearlyChecked') {
      if (isChecked) {
        payload = { year: 'FY' }
      } else {
        payload = { year: 'CY' }
      }
    } else if (year === 'isQuarterlyChecked') {
      payload = { isQuarterly: isChecked }
    } else if (year === 'isMonthlyChecked') {
      payload = { isMonthly: isChecked }
    }

    updateSettings(payload)
  }
  const [modalStatus, setModalStatus] = useState(false)
  const [isModalActive, setIsModalActive] = useState(false)

  return (
    <>
      <div>
        <PageTitle
          breadcrumbs={RecordsKeeperAIBreadCrumbs}
          description={formatMessage({ id: 'Records Classifications' })}
        >
          {formatMessage({ id: 'RecordsKeeper AI' })}
        </PageTitle>
      </div>


      {/* button for desktop view */}
      <div
        // className={`d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block w-25 ${planStatus === 'payment_due' && 'planstatus-adjustment'} ${planStatus === 'paid' && 'planstatus-not-adjustment'}`}>
        className='d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block'
        style={{ top: '80px', right: '30px' }}>
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end gap-4 align-items-center'>
            {/* <Link to='/rk/records-and-files/archieved-files'
              className='font-size-13 text-primary font-weight-400 w-100 text-nowrap'
              onClick={() => setModalStatus(true)}
            >
              {formatMessage({ id: 'Archived Documents' })}
            </Link> */}
            <button
              type='button'
              className='btn bg-primary custom-button-property font-size-13 text-white font-weight-400 w-100 text-nowrap d-flex align-items-center justify-content-center height-36'
              onClick={() => setModalStatus(true)}
            >
              {formatMessage({ id: 'Upload Files' })}
            </button>
            <button
              className={
                `btn w-100 d-flex justify-content-center font-size-13 text-nowrap font-weight-400 custom-button-property d-flex align-items-center height-36 ` +
                (mode === 'dark'
                  ? `btn-outline-primary btn-no-hover-dark`
                  : `btn-outline-primary bg-new-conv-btn btn-no-hover`)
              }
              onClick={() => navigate('/rk/records-and-files/files-request')}
            >
              {formatMessage({ id: 'File Request' })}
            </button>
            <div className='d-flex align-items-center position-relative'>
              <div className='dropdown-export-container'>
                <Dropdown className='height-36'>
                  <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                    <img src={threeDots} alt='' className='three-dots-image' />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className='m-1 rounded'>
                    {/* <Dropdown.Item
                      className='text-dark ps-5 rounded-top border-bottom'
                    >
                      <Link to='/rk/records-and-files/archieved-files' className='text-dark'>
                        {formatMessage({ id: 'Archived Records' })}
                      </Link>
                    </Dropdown.Item> */}
                    <Dropdown.Item
                      className='text-dark ps-5 rounded'
                    >
                      <Link to='/rk/overview/recent-uploads' className='text-dark'>
                        {formatMessage({ id: 'Recent Uploads' })}
                      </Link>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* button for mobile view */}
      <div className='d-flex align-items-center gap-2 gap-lg-3 d-block d-sm-none px-6'>
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex flex-column align-items-center w-100 w-md-auto gap-2 mb-4 mb-md-auto'>
            {/* <Link to='/rk/records-and-files/archieved-files'
              className='font-size-13 text-primary text-center font-weight-400 w-100 text-nowrap'
              onClick={() => setModalStatus(true)}
            >
              {formatMessage({ id: 'Archived Documents' })}
            </Link> */}
            <button
              type='button'
              className='btn bg-primary font-size-13 text-white mb-md-4 mb-0 font-weight-400 w-100 custom-button-property '
            >
              {formatMessage({ id: 'Upload Files' })}
            </button>
            <div className='d-flex w-100 gap-2 align-items-center'>
              <button
                className={
                  `btn px-2 py-3 w-100 custom-button-property ` +
                  (mode === 'dark'
                    ? `btn-outline-primary btn-no-hover-dark`
                    : `btn-outline-primary btn-hover-primary bg-new-conv-btn btn-no-hover`)
                }
                onClick={() => setIsModalActive(true)}
              >
                {formatMessage({ id: 'File Request' })}
              </button>
              <div className='d-flex align-items-center position-relative'>
                <div className='dropdown-export-container'>
                  <Dropdown className='height-40'>
                    <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                      <img src={threeDots} alt='' className='three-dots-image' />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className='m-1 rounded'>
                      {/* <Dropdown.Item
                        className='text-dark ps-5 rounded-top border-bottom'
                      >
                        <Link to='/rk/records-and-files/archieved-files' className='text-dark'>
                          {formatMessage({ id: 'Archived Records' })}
                        </Link>
                      </Dropdown.Item> */}
                      <Dropdown.Item
                        className='text-dark ps-5 rounded'
                      >
                        <Link to='/rk/overview/recent-uploads' className='text-dark'>
                          {formatMessage({ id: 'Recent Uploads' })}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        isModalActive && (
          <RequestFileModal isModalActive={isModalActive} setIsModalActive={setIsModalActive} />
        )

      }
      <FileUpload
        fileSize={parseInt(process.env.REACT_APP_RK_MAX_ZIP_FILE_SIZE as string)}
        maxFileNumber={10}
        allowType={allowedFileTypes}
        metaData={{ module: 'document', isProtected: false }}
        modalStatus={modalStatus}
        handleClose={() => {
          setModalStatus(false)
        }}
        handleSuccess={(id: number, name: string) => {
          toast.success(
            `${name
              .split('/')
              .pop()} uploaded successfully! Please wait for 1-2 minutes while the file is processed with AI. After that you can check the "Records & Files" section or "Overview" section`
          )
        }}
        resourceType='all'
        assemblyOption='rk-doc-upload'
      />

      <div className='px-6'>
        <InfoCard2
          title={'Organizing Files with Categories & Classifications'}
          desc={
            'This page allows you to classify your records based on departments, document types, time periods, projects, and specific entities. Navigate through each level to structure your records for easy access and management. You can add new departments, categories, or cases to ensure all files are properly organized.'
          }
          slug={
            'https://help.recordskeeper.ai/en/articles/10369872-understanding-records-classifications-in-recordskeeper-ai'
          }
        />

        {/* <RecordsKeeperAIGenerator /> */}

        <div
          className='bg-white rounded-2 mt-6 row d-flex flex-nowrap gap-2 mx-1'
          style={{ overflowY: 'hidden', overflowX: 'auto' }}
        >
          {/* level 1 */}
          <div className=' border-end p-4 h-100' style={{ minWidth: '270px', maxWidth: '25%', position: 'relative' }}>
            <h2 className='form-label font-size-14 text-dark fw-bold' style={{ minHeight: '35px' }}>
              {formatMessage({ id: 'Level 1: Departments or Functions' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: 'This represents Level 1 of the categorized records in the RecordsKeeper system, where records are organized by department. Click on a department to view and load its associated Document Type or Categories in the Level 2 window.',
                })}
              />
            </h2>

            <div className='d-flex flex-column justify-content-between' style={{ height: 'calc(100vh - 250px)' }}>
              <div className='my-2' style={{ overflowX: 'hidden', overflowY: 'auto' }}>
                {departmentListLoading ? (
                  <div className='mt-2 d-flex flex-column gap-2'>
                    <Skeleton
                      height={40}
                      count={10}
                      className='my-2'
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                ) : departmentList?.length > 0 ? (
                  departmentList.map((item: any) => (
                    <div
                      key={item.levelOneId}
                      className={`team-folder-list d-flex flex-row align-items-center justify-content-between p-2 cursor-pointer ${selectedFolderLevel1 === item.levelOneId ? 'bg-light' : ''
                        }`}
                    >
                      <div
                        className='d-flex align-items-center gap-2 w-85'
                        onClick={() => {
                          handleFolderSelect(1, item.levelOneId)
                          setClickedDepartment(item?.name)
                        }}
                      >
                        <img src={folderIcon} alt='folderIcon' />
                        <p
                          className={`m-0 ${selectedFolderLevel1 === item.levelOneId ? 'text-primary' : 'text-dark'
                            }`}
                        >
                          {item.name}
                        </p>
                      </div>
                      <div className='dropdown-container d-flex justify-content-center align-items-center pb-1'>
                        <Dropdown
                          show={selectedIndex === item.levelOneId}
                          onToggle={(isOpen) => {
                            setSelectedIndex(isOpen ? item.levelOneId : undefined)
                          }}
                        >
                          <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                            <img src={moreOption} alt='three-dots' className='three-dots-image' />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='m-2'
                            style={{
                              position: 'absolute',
                              zIndex: 1050,
                              top: '100%',
                              left: '0',
                              right: '0',
                            }}>
                            <Dropdown.Item
                              className='text-dark ps-5 rounded-top'
                              onClick={() => {
                                setDepartmentModal(true)
                                setEditDepartmentId(item?.levelOneId)
                                setType('Department')
                                editDetailsClassificationData(item?.levelOneId, 'LevelOne')
                              }}
                            >
                              {formatMessage({ id: 'Edit' })}
                            </Dropdown.Item>

                            <Dropdown.Item
                              className='text-danger ps-5 rounded-bottom'
                              onClick={() => {
                                setOpenDeleteConfirmationModal(true)
                                setDeleteClassificationId(item?.levelOneId)
                                setType('Department')
                                setFileCount(item?.numberOfFile)
                              }}
                            >
                              {formatMessage({ id: 'Delete' })}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='text-center text-muted mt-5'>
                    {formatMessage({ id: 'No departments found' })}
                  </div>
                )}
              </div>

              <div className='w-100'>
                <button
                  className={`btn btn-outline-primary text-primary text-center w-100 bg-hover-primary text-hover-white`}
                  style={mode === 'dark' ? { background: 'transparent' } : { background: '#F0F4FF' }}
                  onClick={() => {
                    setDepartmentModal(true)
                  }}
                >
                  {formatMessage({ id: 'Add New Department' })}
                </button>
              </div>
            </div>
          </div>

          {/* level 2 */}
          <div className='border-end p-4' style={{ minWidth: '270px', maxWidth: '25%', position: 'relative' }}>
            <h2 className='form-label font-size-14 text-dark fw-bold' style={{ minHeight: '35px' }}>
              {formatMessage({ id: 'Level 2: Document Types or Categories' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: 'This represents Level 2 of the categorized records in the RecordsKeeper system, where records are organized by Document Type or Category. Click on a Document Type or Category to view and load its Projects, Cases or Entities in the Level 4 window.',
                })}
              />
            </h2>

            <div className='d-flex flex-column justify-content-between' style={{ height: 'calc(100vh - 250px)' }}>
              <div className='h-600px my-2' style={{ overflowX: 'hidden', overflowY: 'auto' }}>
                {categoryListLoading ? (
                  <div className='mt-2 d-flex flex-column gap-2'>
                    <Skeleton
                      height={40}
                      count={10}
                      className='my-2'
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                ) : categoryList?.length > 0 ? (
                  categoryList.map((item: any) => (
                    <div
                      key={item.Id}
                      className={`team-folder-list d-flex flex-row align-items-center justify-content-between p-2 cursor-pointer ${selectedFolderLevel2 === item.levelTwoId ? 'bg-light' : ''
                        }`}
                      onClick={() => {
                        handleFolderSelect(2, item.levelTwoId)
                        setClickedCategory(item?.name)
                      }}
                    >
                      <div className='d-flex align-items-center gap-2'>
                        <img src={folderIcon} alt='folderIcon' />
                        <p
                          className={`m-0 ${selectedFolderLevel2 === item.levelTwoId ? 'text-primary' : 'text-dark'
                            }`}
                        >
                          {item.name}
                        </p>
                      </div>

                      <div className='dropdown-container d-flex justify-content-center align-items-center pb-1'>
                        <Dropdown
                          show={selectedIndex === item.levelTwoId}
                          onToggle={(isOpen) => {
                            setSelectedIndex(isOpen ? item.levelTwoId : undefined)
                          }}
                        >
                          <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                            <img src={moreOption} alt='three-dots' className='three-dots-image' />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='m-2'
                            style={{
                              position: 'absolute',
                              zIndex: 1050,
                              top: '100%',
                              left: '0',
                              right: '0',
                            }}>
                            <Dropdown.Item
                              className='text-dark ps-5 rounded-top'
                              onClick={() => {
                                setCategoryModal(true)
                                setEditDepartmentId(item?.levelTwoId)
                                setType('Category')
                                editDetailsClassificationData(item?.levelTwoId, 'LevelTwo')
                              }}
                            >
                              {formatMessage({ id: 'Edit' })}
                            </Dropdown.Item>

                            <Dropdown.Item
                              className='text-danger ps-5 rounded-bottom'
                              onClick={() => {
                                setOpenDeleteConfirmationModal(true)
                                setDeleteClassificationId(item?.levelTwoId)
                                setType('Category')
                                setFileCount(item?.numberOfFile)
                              }}
                            >
                              {formatMessage({ id: 'Delete' })}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className='text-center text-muted mt-5'>
                    {formatMessage({ id: 'No categories found' })}
                  </div>
                )}
              </div>

              <div className='w-100'>
                <button
                  className={`btn btn-outline-primary text-primary text-center w-100 bg-hover-primary text-hover-white`}
                  style={mode === 'dark' ? { background: 'transparent' } : { background: '#F0F4FF' }}
                  onClick={() => {
                    setCategoryModal(true)
                  }}
                  disabled={departmentList?.length === 0}
                >
                  {formatMessage({ id: 'Add New Category' })}
                </button>
              </div>
            </div>
          </div>

          {/* level 3 */}
          <div className='border-end p-4 d-none' style={{ minWidth: '270px', maxWidth: '25%' }}>
            <h2 className='form-label font-size-14 text-dark fw-bold' style={{ minHeight: '35px' }}>
              {formatMessage({ id: 'Level 3: Year/Time Period' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: 'This represents Level 3 of the categorized records in the RecordsKeeper system, where records are organized by Year (Financial or Calendar Year), Quarter & Month. Click on a Document Type or Category to view and load its Projects, Cases or Entities in the Level 4 window.',
                })}
              />
            </h2>
            <div className='d-flex flex-column justify-content-between' style={{ height: 'calc(100vh - 250px)' }}>
              <div className='h-600px my-2' style={{ overflowX: 'hidden', overflowY: 'auto' }}>
                {timePeriodLoading ? (
                  <div className='mt-2 d-flex flex-column gap-2'>
                    <Skeleton
                      height={40}
                      count={10}
                      className='my-2'
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                ) : (
                  <>
                    {/* Year Level */}

                    <div className='team-folder-list d-flex flex-column cursor-pointer'>
                      {/* Yearly Toggle */}
                      <div className='d-flex flex-row justify-content-between p-2'>
                        <div className='d-flex align-items-center'>
                          <img src={folderIcon} alt='folder' />

                          <span
                            className={`ms-2 ${toggleStates['isYearlyChecked'] ? 'text-primary' : ''
                              }`}
                          >
                            {toggleStates['isYearlyChecked']
                              ? formatMessage({ id: `Financial Year (${settingsData?.financialYear})` })
                              : formatMessage({ id: 'Calendar Year (Jan-Dec)' })}
                          </span>
                        </div>
                        <label className='toggle'>
                          <input
                            className='toggle__input'
                            name={`Yearly`}
                            type='checkbox'
                            checked={toggleStates['isYearlyChecked']}
                            onChange={(e) => handleToggle(e, 'isYearlyChecked')}
                          />
                          <div className='toggle__fill'></div>
                        </label>
                      </div>

                      {/* Quarterly Toggle */}
                      <div className='d-flex flex-row justify-content-between p-2'>
                        <div className='d-flex align-items-center'>
                          <img src={folderIcon} alt='folder' />
                          <span
                            className={`ms-2 ${toggleStates['isQuarterlyChecked'] ? 'text-primary' : ''
                              }`}
                          >
                            {formatMessage({ id: 'Quarterly' })}
                          </span>
                        </div>
                        <label className='toggle'>
                          <input
                            className='toggle__input'
                            name={`Quarterly`}
                            type='checkbox'
                            checked={toggleStates['isQuarterlyChecked']}
                            onChange={(e) => handleToggle(e, 'isQuarterlyChecked')}
                          />
                          <div className='toggle__fill'></div>
                        </label>
                      </div>

                      {/* Monthly Toggle */}
                      <div className='d-flex flex-row justify-content-between p-2'>
                        <div className='d-flex align-items-center'>
                          <img src={folderIcon} alt='folder' />
                          <span
                            className={`ms-2 ${toggleStates['isMonthlyChecked'] ? 'text-primary' : ''
                              }`}
                          >
                            {formatMessage({ id: 'Monthly' })}
                          </span>
                        </div>
                        <label className='toggle'>
                          <input
                            className='toggle__input'
                            name={`Monthly`}
                            type='checkbox'
                            checked={toggleStates['isMonthlyChecked']}
                            onChange={(e) => handleToggle(e, 'isMonthlyChecked')}
                          />
                          <div className='toggle__fill'></div>
                        </label>
                      </div>

                      {/* Not Known */}
                      <div className='p-2'>
                        <img src={folderIcon} alt='folder' />
                        <span className='ms-2'>{formatMessage({ id: 'Not Known' })}</span>
                      </div>
                    </div>

                    {/* Unknown Toggle */}
                  </>
                )}
              </div>
            </div>
          </div>

          {/* level 4 */}
          <div className='border-end p-4' style={{ minWidth: '270px', maxWidth: '25%', position: 'relative' }}>
            <h2 className='form-label font-size-14 text-dark fw-bold' style={{ minHeight: '35px' }}>
              {formatMessage({ id: 'Level 3: Projects, Cases, or Entities' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: 'This represents Level 3 of the categorized records in the RecordsKeeper system, where records are organized by Projects, Cases or Entities. Click on a Project, Case or Entity to view and load its associated Files.',
                })}
              />
            </h2>

            <div className='d-flex flex-column justify-content-between' style={{ height: 'calc(100vh - 250px)' }}>
              <div className='h-600px my-2' style={{ overflowX: 'hidden', overflowY: 'auto' }}>
                {projectListLoading ? (
                  <div className='mt-2 d-flex flex-column gap-2'>
                    <Skeleton
                      height={40}
                      count={10}
                      className='my-2'
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                ) : projectList?.length > 0 ? ( // Add this condition
                  projectList.map((item: any) => (
                    <div
                      key={item.projectId}
                      className={`team-folder-list d-flex flex-row align-items-center justify-content-between p-2 cursor-pointer ${selectedFolderLevel4 === item.levelThreeId ? 'bg-light' : ''
                        }`}
                      onClick={() => handleFolderSelect(4, item.levelThreeId)}
                    >
                      <div className='d-flex align-items-center gap-2'>
                        <img src={folderIcon} alt='folderIcon' />
                        <p
                          className={`m-0 ${selectedFolderLevel4 === item.levelThreeId ? 'text-primary' : 'text-dark'
                            }`}
                        >
                          {item.name}
                        </p>
                      </div>

                      <div className='dropdown-container d-flex justify-content-center align-items-center pb-1'>
                        <Dropdown
                          onToggle={(isOpen) => {
                            setSelectedIndex(isOpen ? item.levelThreeId : undefined)
                          }}
                        >
                          <Dropdown.Toggle className='btn btn-white table-three-dots dots-container'>
                            <img src={moreOption} alt='three-dots' className='three-dots-image' />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className='m-2'
                            style={{
                              position: 'absolute',
                              zIndex: 1050,
                              top: '100%',
                              left: '0',
                              right: '0',
                            }}>
                            <Dropdown.Item
                              className='text-dark ps-5 rounded-top'
                              onClick={() => {
                                setProjectModal(true)
                                setEditDepartmentId(item?.levelThreeId)
                                setType('Case')
                                editDetailsClassificationData(item?.levelThreeId, 'LevelThree')
                              }}
                            >
                              {formatMessage({ id: 'Edit' })}
                            </Dropdown.Item>

                            <Dropdown.Item
                              className='text-danger ps-5 rounded-bottom'
                              onClick={() => {
                                setOpenDeleteConfirmationModal(true)
                                setDeleteClassificationId(item?.levelThreeId)
                                setType('Case')
                                setFileCount(item?.numberOfFile)
                              }}
                            >
                              {formatMessage({ id: 'Delete' })}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className='text-center text-muted mt-5'>
                    {formatMessage({ id: 'No projects found' })}
                  </p>
                )}
              </div>

              <div className='w-100'>
                <button
                  className={`btn btn-outline-primary text-primary text-center w-100 bg-hover-primary text-hover-white`}
                  style={mode === 'dark' ? { background: 'transparent' } : { background: '#F0F4FF' }}
                  onClick={() => {
                    setProjectModal(true)
                  }}
                  disabled={categoryList?.length === 0}
                >
                  {formatMessage({ id: 'Add New Case' })}
                </button>
              </div>
            </div>
          </div>

          {/* level 5 */}
          <div className='w-25 p-4' style={{ minWidth: '270px', maxWidth: '25%' }}>
            <h2 className='form-label font-size-14 text-dark fw-bold' style={{ minHeight: '35px' }}>
              {formatMessage({ id: 'Level 4: Specific Document' })}
              <ToolTipUI
                tooltipText={formatMessage({
                  id: 'This is the final level, Level 4, where all the files are stored and available for retrieval.',
                })}
              />
            </h2>
            <div className='d-flex align-items-center justify-content-center flex-column ' style={{ height: 'calc(100vh - 250px)' }}>
              <div className='h-600px my-2 d-flex flex-column justify-content-center align-items-center' style={{ overflowX: 'hidden', overflowY: 'auto' }}>
                <img alt='Logo' src={toAbsoluteUrl('/media/icons/RecordsKeeperAI/file-pic.svg')} />
                <div className='level5-header mt-3'>{formatMessage({ id: 'This Is Where Your Files Will Be' })}</div>
                <div className='level5-para text-center mt-3 mb-3'>
                  {formatMessage({ id: 'At this categorization level, you will find and access all your files easily.' })}
                </div>
                <button
                  className='btn bg-primary text-white custom-button-property mt-3 mt-md-0 w-100 w-md-auto'
                  onClick={() => {
                    navigate('/rk/records-and-files')
                  }}
                >
                  {formatMessage({ id: 'Go to Files' })}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DepartmentModal
        isActive={departmentModal}
        setIsActive={setDepartmentModal}
        getDepartmentList={getDepartmentList}
        editDetailsData={type === 'Department' ? editDetailsData : undefined}
        setEditDetailsData={setEditDetailsData}
        editDetailsLoading={editDetailsLoading}
        editDepartmentId={type === 'Department' ? editDepartmentId : undefined}
        settingsData={settingsData}
      />
      <AddCategoryModal
        isActive={categoryModal}
        setIsActive={setCategoryModal}
        selectedDepartmentFolder={selectedFolderLevel1}
        getCategoryList={getCategoryList}
        editDetailsData={type === 'Category' ? editDetailsData : undefined}
        setEditDetailsData={setEditDetailsData}
        editDetailsLoading={editDetailsLoading}
        editDepartmentId={type === 'Category' ? editDepartmentId : undefined}
        settingsData={settingsData}
        clickedDepartment={clickedDepartment}
      />
      <AddProjectModal
        isActive={projectModal}
        setIsActive={setProjectModal}
        selectedCategoryFolder={selectedFolderLevel2}
        getProjectList={getProjectList}
        editDetailsData={type === 'Case' ? editDetailsData : undefined}
        setEditDetailsData={setEditDetailsData}
        editDetailsLoading={editDetailsLoading}
        editDepartmentId={type === 'Case' ? editDepartmentId : undefined}
        settingsData={settingsData}
        clickedDepartment={clickedDepartment}
        clickedCategory={clickedCategory}
      />
      <DeleteClassificationModal
        setDeleteShowModal={setOpenDeleteConfirmationModal}
        showDeleteModal={openDeleteConfirmationModal}
        handleDelete={handleDeleteClassification}
        deleteLoading={deleteLoading}
        headingMessage={`Delete ${type}`}
        description={`This ${type} has ${fileCount} numbers of files. Do you still want to delete it? You can not undo this action.`}
      />
    </>
  )
}

export default RecordsClassifications
